<template>
  <section ref="panel">
    <SectionHeading class="heading" icon="icon-saving-piggy-coins" title="Tour Price" />

    <ItineraryPriceAndCta />

    <div v-if="isBNPLEnabled" class="bnpl-container">
      Pay later with<br />
      <div class="bnpl-container__images">
        <img src="app/assets/images/payment/affirm.svg" alt="affirm" style="height: 20px" />
        or
        <img src="app/assets/images/payment/klarna.svg" alt="klarna" style="height: 20px" />
      </div>
    </div>
    <div v-else-if="installmentPrice && installmentPrice.amount.cents < minimumCheckoutTierPricing.priceCents">
      Flexible payment plans available
    </div>
    <div v-else-if="showDepositSubtext">
      {{ currencyFormat(reservePrice.cents, reservePrice.currencyIso, true) }} deposit only
    </div>
  </section>
</template>

<script setup lang="ts">
import { useItineraryStore } from '@/stores/itinerary.js'
import SectionHeading from '@/modules/Itinerary/Components/SectionHeading.vue'
import { currencyFormat } from '@/utils/numberUtils.js'
import { onMounted, ref, watch } from 'vue'
import { useElementVisibility } from '@vueuse/core'
import ItineraryPriceAndCta from '@/modules/Itinerary/Components/ItineraryPriceAndCta.vue'
import { useBnplInfo } from '@/helpers/hooks'
import { logErrorOnSentry } from '@/utils/errorReportingUtils.js'

const panel = ref()
const store = useItineraryStore()
const {
  data: { minimumCheckoutTierPricing, showDepositSubtext, reservePrice, installmentPrice, itinerary },
} = store
const isBNPLEnabled = ref(false)

onMounted(async () => {
  if (store.isProjectionPreview) return

  try {
    const bnplInfo = await useBnplInfo(itinerary.id)
    isBNPLEnabled.value = bnplInfo.isBnplEnabled
  } catch (error) {
    logErrorOnSentry(error, { component: 'ItineraryPrice', function: 'useBnplInfo' })
  }
})

const isVisible = useElementVisibility(panel)
watch(isVisible, visible => (store.pricePanelIsVisible = visible))
</script>

<style lang="scss" scoped>
section {
  background: white;
  color: $grey-100;
  text-align: center;
  @include flex-column(16px);
  transform: translateY(0);

  @include mobile {
    border-radius: 15px;
    border: 1px solid $grey-50;
    padding: 24px;
  }
}

.heading {
  margin-right: auto;
}

.bnpl-container {
  display: flex;
  flex-direction: column;
  gap: $spacing-2;

  .bnpl-container__images {
    display: flex;
    gap: $spacing-2;
    justify-content: center;
  }
}
</style>
